import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col">
      <Navigation />
      <main className="flex-1 grid place-items-center pt-32 pb-20 px-4">
        <div className="text-center max-w-xl">
          <p className="text-xs uppercase tracking-[0.3em] text-primary mb-4">404 · Not found</p>
          <h1 className="font-display text-7xl md:text-8xl tracking-tight mb-4 gradient-text">
            Lost the path.
          </h1>
          <p className="text-muted-foreground mb-8">
            The page you&rsquo;re looking for doesn&rsquo;t exist — but help is just one step away.
          </p>
          <Button asChild size="lg" className="rounded-full bg-primary text-primary-foreground hover:bg-primary/90 font-semibold h-12 px-7">
            <Link to="/"><ArrowLeft className="w-4 h-4 mr-2" /> Back home</Link>
          </Button>
        </div>
      </main>
      <Footer />
    </div>
  );
}
